import { useRef, useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { PUBLIC_URL } from "../serviceWorker";
import { useNavigate } from "react-router-dom";
import { Product } from "../actions/types";

const SearchProducts = () => {
  const SEARCH_URI = PUBLIC_URL + "api/shop/fetch_search";
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef<any>(null);
  const navigate: any = useNavigate();
  const [options, setOptions] = useState<Product[]>([]);
  const container = document.getElementById("container") as HTMLDivElement;

  const handleSearch = (query: string) => {
    setIsLoading(true);
    fetch(`${SEARCH_URI}?q=${query}`)
      .then((resp) => resp.json())
      .then(({ items }) => {
        setIsLoading(false);
        if (query.length === 12 && items.length === 1) {
          setOptions([]);
          ref.current.clear();
          navigate("/product/" + items[0].id);
        } else {
          setOptions(items);
        }
      })
      .catch(() => setIsLoading(false));
  };

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <div style={{ minWidth: "300px" }} className="me-3 buscador-container">
      <AsyncTypeahead
        filterBy={filterBy}
        ref={ref}
        id="async-example"
        isLoading={isLoading}
        labelKey="name"
        minLength={3}
        onSearch={handleSearch}
        options={options}
        placeholder="Buscar productos..."
        emptyLabel="No se encontraron productos"
        searchText="Buscando..."
        promptText="Escribe algo para buscar"
        size="lg"
        clearButton
        onChange={(option: any) => {
          if (option.length) {
            navigate("/product/" + option[0].id);
            ref.current.clear();
            container?.click();
          }
        }}
        renderMenuItemChildren={(option: Product | any, props, index) => {
          const imageUrl = option?.path
            ? option.path.startsWith("http")
              ? option.path
              : `${PUBLIC_URL}${option.path}`
            : null;

          return (
            <div
              key={index}
              className="d-flex align-items-center py-1 overflow-hidden"
              style={{ width: "100%" }}
            >
              {imageUrl ? (
                <img
                  alt={option.name}
                  src={imageUrl}
                  style={{
                    height: "50px",
                    width: "50px",
                    marginRight: "15px",
                    objectFit: "cover",
                    borderRadius: "4px",
                  }}
                />
              ) : (
                <div
                  style={{
                    height: "50px",
                    width: "50px",
                    marginRight: "15px",
                    background: "#eee",
                    borderRadius: "4px",
                  }}
                />
              )}
              <div className="d-flex flex-column flex-grow-1 overflow-hidden">
                <strong
                  style={{ fontSize: "1rem", lineHeight: "1.2" }}
                  className="text-truncate"
                >
                  {option.name}
                </strong>
                {option.description && (
                  <small
                    className="text-muted text-truncate"
                    style={{ display: "block" }}
                  >
                    {option.description}
                  </small>
                )}
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default SearchProducts;
